import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles({
  listWrapper: {
    lineHeight: '120%',
  },
  paddingTop: {
    '&::before': {
      content: "' '",
      display: 'block',
      paddingTop: '80px',
      visibility: 'hidden',
    },
  },
})
